"use client";
import { FC, ReactNode, useState } from "react";
import { DialogModal } from "@/components/Modal";
import { useMaturityModelContext } from "../MaturityModelContext";
import InteractiveCard from "./InteractiveCard";
import NotificationModal from "./NotificationModal";
import { Button } from "@/components/Button";

type RegistrationFormSectionProps = {
  header?: string;
  description?: string;
  ctaName?: string;
  analytics?: {
    dlt: string;
    dld: string;
  };
  incompleteTableError?: {
    header?: string;
    description?: string;
  };
  underReview?: {
    header?: string;
    description?: string;
  };
  isUnderReview?: boolean;
  registrationForm?: ReactNode;
};

const RegistrationFormSection: FC<RegistrationFormSectionProps> = ({
  header,
  description,
  ctaName,
  analytics,
  incompleteTableError,
  underReview,
  isUnderReview,
  registrationForm,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const maturityModelContext = useMaturityModelContext();
  const hasSelectedItems = maturityModelContext?.hasSelectedItems ?? false;
  const hasSelectedChallenge =
    maturityModelContext?.hasSelectedChallenge ?? false;

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const showNotification =
    isUnderReview || (!hasSelectedItems && !hasSelectedChallenge);

  const notificationHeader = isUnderReview
    ? underReview?.header
    : incompleteTableError?.header;

  const notificationDescription = isUnderReview
    ? underReview?.description
    : incompleteTableError?.description;

  const activeModal = showNotification ? (
    <NotificationModal
      open={isModalOpen}
      onClose={closeModal}
      header={notificationHeader}
      description={notificationDescription}
    />
  ) : (
    <DialogModal
      open={isModalOpen}
      onClose={closeModal}
      maxWidth={undefined}
      panelClassName="max-w-146 p-8!"
    >
      {registrationForm}
    </DialogModal>
  );

  return (
    <InteractiveCard header={header}>
      <div className="flex basis-full flex-col items-center justify-between pb-6">
        {description && (
          <div className="text-body-m text-swdc-gray-400 my-6 font-normal">
            {description}
          </div>
        )}
        {ctaName && (
          <Button
            variant="primary"
            onClick={openModal}
            dld={analytics?.dld}
            dlt={analytics?.dlt}
            disabled={isUnderReview}
          >
            {ctaName}
          </Button>
        )}
        {activeModal}
      </div>
    </InteractiveCard>
  );
};

export default RegistrationFormSection;
